import React from 'react'
import image from '../../../../assets/ogc.png'
function BannerInfo() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal">
    <div className="card-body">
      
      <p className=" card-text ">
      Los geoservicios brindan la posibilidad de acceder, de manera directa, a la información
geográfica existente en las bases de datos del Gobierno de la Ciudad, aportada por las distintas
áreas productoras, de manera estandarizada e interoperable, asegurando la actualización
permanente de la misma. <br/><br/>
Estos geoservicios se ajustan a las normas y estándares del OGC (Open Geospatial Consortium)
      </p>
    </div>
    <img src={image} alt="descripción de imagen" className="panel-img" style={({height: 'auto', objectFit: 'contain'})}/>
  </div>
</div>

  )
}

export default BannerInfo

